import { render, staticRenderFns } from "./ProgramacaoHome.vue?vue&type=template&id=faa63b42&scoped=true&"
import script from "./ProgramacaoHome.vue?vue&type=script&lang=js&"
export * from "./ProgramacaoHome.vue?vue&type=script&lang=js&"
import style0 from "./ProgramacaoHome.vue?vue&type=style&index=0&id=faa63b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa63b42",
  null
  
)

export default component.exports